(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faith-unfiltered-landing-v2"] && !Shopify.designMode) return;
  try {
    
  const instagramEmbedScript = 'https://www.instagram.com/embed.js';

  if (document.querySelector('.fu-launch .instagram-media')) {
    const processEmbeds = () => {
      if (window.instgrm?.Embeds) {
        window.instgrm.Embeds.process();
      }
    };

    if (document.querySelector(`script[src="${instagramEmbedScript}"]`)) {
      processEmbeds();
    } else {
      const script = document.createElement('script');
      script.async = true;
      script.src = instagramEmbedScript;
      script.addEventListener('load', processEmbeds);
      document.head.appendChild(script);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faith-unfiltered-landing"] && !Shopify.designMode) return;
  try {
    
  const instagramEmbedScript = 'https://www.instagram.com/embed.js';

  if (document.querySelector('.fu-launch .instagram-media')) {
    const processEmbeds = () => {
      if (window.instgrm?.Embeds) {
        window.instgrm.Embeds.process();
      }
    };

    if (document.querySelector(`script[src="${instagramEmbedScript}"]`)) {
      processEmbeds();
    } else {
      const script = document.createElement('script');
      script.async = true;
      script.src = instagramEmbedScript;
      script.addEventListener('load', processEmbeds);
      document.head.appendChild(script);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
